import React from 'react';
import PropTypes from 'prop-types';
import { resolve } from '@cvent/nucleus-dynamic-css';
import SpeakerFilters, { filterSpeakers } from './SpeakerFilters.js';
import { Speaker as SpeakerType, SpeakerCategory as SpeakerCategoryType,
  SpeakerDisplayOptions } from '../../interfaces/eventPropTypes';
import { resolveTestId } from '@cvent/nucleus-test-automation';
import SpeakerBioModal from './Modal/SpeakerBioModal';
import { Grid, Container } from 'nucleus-core/layout/grid';
import SpeakersList from './SpeakersList';
import SpeakersWidgetBehavior from './SpeakersWidgetBehavior';

export default class Speakers extends React.PureComponent {
  static displayName = 'Speakers';
  static contextType = SpeakersWidgetBehavior;
  static propTypes = {
    style: PropTypes.any.isRequired,
    classes: PropTypes.any.isRequired,
    translate: PropTypes.func.isRequired,
    speakers: PropTypes.arrayOf(SpeakerType),
    displayOptions: SpeakerDisplayOptions,
    viewBioModal: PropTypes.shape({
      displayModal: PropTypes.bool.isRequired,
      modalButtonText: PropTypes.string.isRequired,
      modalDisplayOptions: PropTypes.arrayOf(PropTypes.string)
    }),
    speakerCategories: PropTypes.arrayOf(SpeakerCategoryType),
    filter: PropTypes.shape({
      categoryGrouping: PropTypes.bool,
      displayKeywordFilter: PropTypes.bool
    }),
    dialogContainerStyle: PropTypes.any.isRequired,
    loadSpeakerDocuments: PropTypes.func,
    getSpeakerDocuments: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.state = {
      selectedSpeakerId: null,
      keywordFilterValue: ''
    };
  }

  showBioModal = (id) => {
    if (id !== this.state.selectedSpeakerId) {
      this.setState({ selectedSpeakerId: id });

      if (this.context.recordViewSpeakerProfileActivity) {
        this.context.recordViewSpeakerProfileActivity(id);
      }
    }
  }

  onKeywordFilterUpdate = (keyword) => {
    this.setState({ keywordFilterValue: keyword });
  };

  getSpeakerFiltersComponent() {
    const { filter: { displayKeywordFilter } = {} } = this.props;
    return (displayKeywordFilter &&
    <SpeakerFilters
      {...this.props}
      updateKeywordFilter={this.onKeywordFilterUpdate}
      keywordFilterValue={this.state.keywordFilterValue}
    />
    );
  }

  generateSpeakersComponent(categoryGrouping, speakerCategories, speakers) {
    const speakerList = (
      <SpeakersList
        {...this.props}
        showBioModal={this.showBioModal}
        speakerCategories={speakerCategories}
        categoryGrouping={categoryGrouping}
        keywordFilterValue={this.state.keywordFilterValue}
        speakers={speakers}
      />
    );
    if (categoryGrouping) {
      return (
        <Grid>
          <Container
            {...resolve(this.props, 'gridContainerGrouping')}
            {...resolveTestId(this.props, '-gridContainerGrouping')}
          >
            { this.getSpeakerFiltersComponent() }
            { speakerList }
          </Container>
        </Grid>
      );
    }
    return (
      <Grid>
        <Container {...resolve(this.props, 'gridContainer')} {...resolveTestId(this.props, '-gridContainer')}>
          { this.getSpeakerFiltersComponent() }
          { speakerList }
        </Container>
      </Grid>
    );
  }

  /**
   * First Name, Last Name - Always check
   * Prefix, Company, Title - Check if turned on for speaker card or speaker modal
   * Category - Check if turned on in the speakers modal or Group By Category
   * Designation, Biography - Check if turned on in speakers modal
   */
  getSearchByFields() {
    const { viewBioModal: { displayModal, modalDisplayOptions },
      filter: { categoryGrouping } = {}, displayOptions } = this.props;
    return {
      prefix: displayOptions.prefix || (displayModal && modalDisplayOptions.includes('prefix')),
      title: displayOptions.title || (displayModal && modalDisplayOptions.includes('title')),
      company: displayOptions.company || (displayModal && modalDisplayOptions.includes('company')),
      firstName: true,
      lastName: true,
      category: categoryGrouping || (displayModal && modalDisplayOptions.includes('category')),
      biography: displayModal && modalDisplayOptions.includes('biography'),
      designation: displayModal && modalDisplayOptions.includes('designation')
    };
  }

  render() {
    const { speakers = [], speakerCategories = [], classes, style, viewBioModal: { displayModal,
      modalDisplayOptions }, filter: { categoryGrouping } = {}, translate, dialogContainerStyle,
    loadSpeakerDocuments, getSpeakerDocuments } = this.props;
    const filteredSpeakers = filterSpeakers(speakers, this.getSearchByFields(), this.state.keywordFilterValue);
    const speakersComponent = this.generateSpeakersComponent(categoryGrouping, speakerCategories, filteredSpeakers);
    const selectedSpeaker = filteredSpeakers.find(speaker => speaker.id === this.state.selectedSpeakerId);
    const selectedSpeakerCategory =
      selectedSpeaker ?
        speakerCategories.find(speakerCategory => speakerCategory.id === selectedSpeaker.categoryId) : null;

    return (
      <div>
        { speakersComponent }
        { displayModal && selectedSpeaker &&
          <div>
            <SpeakerBioModal
              classes={classes}
              style={style}
              translate={translate}
              speaker={selectedSpeaker}
              speakerCategory={selectedSpeakerCategory}
              loadSpeakerDocuments={loadSpeakerDocuments}
              getSpeakerDocuments={getSpeakerDocuments}
              showBioModal={this.showBioModal}
              displayOptions={modalDisplayOptions}
              dialogContainerStyle={dialogContainerStyle}
            />
          </div> }
      </div>
    );
  }
}
